module.exports = __webpack_public_path__ + "static/media/phone_mobile.c89ea4da.png";